import Schedule from './Schedule';

export default Schedule;
